import { useLocation } from 'react-router';

export default () => {
  const location = useLocation();
  return new URLSearchParams(location.search);
};
